import React, { useState, useEffect } from "react";
import { RiCloseFill } from "react-icons/ri";
import axios from "axios";
import Swal from "sweetalert2";

import CustomSelect from "../../capture/custom-select";
import "../entries.css";

const LocationsModal = ({
  master,
  onClose,
  locationsData,
  selectedId,
  type,
  loading,
  setLoading,
}) => {
  const [rows, setRows] = useState([]);
  const [totalsMatch, setTotalsMatch] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [saving, setSaving] = useState(false);

  const locationOptions =
    locationsData?.alLocations?.map((loc) => ({
      id: Number(loc.location_id),
      name: loc.name,
    })) || [];

  console.log(type);

  const getItem = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/location/searchExpHouse_loc`,
        {
          type: type === "directa" ? "master" : "house",
          master_id: locationsData.resp.id,
          type_h: locationsData.house_type,
          house_id: selectedId,
          house_edited: "yes",
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        },
      );

      if (res.data.code === 1 && res.data.data) {
        const initialRows = res.data.data.map((item, index) => {
          const locationId = Number(item.id_location);

          return {
            id: index + 1,
            pzas: item.pieces || "",
            peso: item.weight || "",
            locacion: {
              id: locationId,
              name:
                locationOptions.find((loc) => loc.id === locationId)?.name ||
                "",
            },
            dbId: item.id,
          };
        });

        setRows(initialRows);
        calculateTotals(initialRows);
      }
    } catch (error) {
      console.error("Error fetching location items:", error);
    } finally {
      setLoading(false);
    }
  };

  const calculateTotals = (rowsToCalculate) => {
    let totalPzas = 0;
    let totalPeso = 0;

    for (let i = 0; i < rowsToCalculate.length; i++) {
      const row = rowsToCalculate[i];

      if (row.pzas && !isNaN(parseFloat(row.pzas))) {
        totalPzas += parseFloat(row.pzas);
      }

      if (row.peso && !isNaN(parseFloat(row.peso))) {
        totalPeso += parseFloat(row.peso);
      }
    }

    const masterPieces = parseFloat(locationsData?.resp?.pieces) || 0;
    const masterWeight = parseFloat(locationsData?.resp?.weight) || 0;
    const tolerance = 0.01;
    const piecesMatch = Math.abs(totalPzas - masterPieces) < tolerance;
    const weightMatch = Math.abs(totalPeso - masterWeight) < tolerance;

    setTotalsMatch(piecesMatch && weightMatch);
  };

  const handleAddRow = () => {
    const newId =
      rows.length > 0 ? Math.max(...rows.map((row) => row.id)) + 1 : 1;
    const newRows = [
      ...rows,
      {
        id: newId,
        pzas: "",
        peso: "",
        locacion: { id: "", name: "" },
      },
    ];
    setRows(newRows);
    calculateTotals(newRows);
  };

  const handleDeleteRow = (id) => {
    const newRows = rows
      .filter((row) => row.id !== id)
      .map((row, i) => ({ ...row, id: i + 1 }));

    setRows(newRows);
    calculateTotals(newRows);
  };

  const handleInputChange = (id, field, value) => {
    const numericValue = parseFloat(value);
    if (numericValue < 0) return;

    const newRows = rows.map((row) =>
      row.id === id ? { ...row, [field]: value } : row,
    );

    setRows(newRows);
    calculateTotals(newRows);
  };

  const handleLocationChange = (id, selectedLocation) => {
    const newRows = rows.map((row) =>
      row.id === id ? { ...row, locacion: selectedLocation } : row,
    );

    setRows(newRows);
  };

  useEffect(() => {
    getItem();
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const handleAccept = async () => {
    if (!totalsMatch) {
      Swal.fire({
        title: "Los totales no coinciden. Por favor verifica.",
        icon: "warning",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
      return;
    }

    const rowsWithoutLocation = rows.filter(
      (row) => !row.locacion.id || row.locacion.id === "",
    );

    if (rowsWithoutLocation.length > 0) {
      Swal.fire({
        title: "Por favor selecciona una locación para todas las filas.",
        icon: "warning",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
      return;
    }

    const rowsWithoutData = rows.filter(
      (row) => !row.pzas || row.pzas === "" || !row.peso || row.peso === "",
    );

    if (rowsWithoutData.length > 0) {
      Swal.fire({
        title: "Por favor completa todos los campos de piezas y peso.",
        icon: "warning",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
      return;
    }

    setSaving(true);
    setLoading(true);

    try {
      const userData = localStorage.getItem("user");
      const user = userData ? JSON.parse(userData) : null;
      const user_id = user?.id || 1;

      const requestData = {
        master_id: locationsData.resp.id,
        tipo: type === "parcial" ? "house" : "master",
        type_h: locationsData.house_type,
        house_id: selectedId,
        piezas: rows.map((row) => row.pzas.toString()),
        peso: rows.map((row) => row.peso.toString()),
        locaciones: rows.map((row) => parseInt(row.locacion.id)),
        user_id: user_id,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/location/saveExpHouse_loc`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.code === 1) {
        Swal.fire({
          title: "Locaciones guardadas exitosamente",
          icon: "success",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
        setLoading(false);
        onClose();
      } else {
        setLoading(false);
        Swal.fire({
          title: "Error al guardar",
          icon: "error",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }
    } catch (error) {
      console.error("Error al guardar locaciones:", error);
      console.error("Error response:", error.response?.data);

      let errorMessage = "Error al guardar las locaciones";
      if (error.response?.data?.message) {
        errorMessage += `: ${error.response.data.message}`;
      }
      setLoading(false);
    } finally {
      setLoading(false);
      setSaving(false);
    }
  };

  const masterPieces =
    locationsData?.resp?.pieces || master?.resp?.master_pieces || "N/A";
  const masterWeight =
    locationsData?.resp?.weight || master?.resp?.master_weight || "N/A";

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 1050,
      }}
    >
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1040,
        }}
      />
      <div
        className={`modal-dialog modal-lg ${
          isClosing ? "modal-slide-up" : "modal-slide-down"
        }`}
        style={{
          position: "relative",
          zIndex: 1060,
          margin: "5vh auto",
        }}
      >
        <div className="modal-content">
          <div
            className="modal-header"
            style={{
              backgroundColor: "#020C41",
              color: "white",
              padding: "0.5rem 1rem",
            }}
          >
            <h5 className="modal-title m-0">Bultos y Locaciones</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={handleClose}
            ></button>
          </div>

          <div className="modal-body container-fluid">
            <div className="row text-center mt-4 mb-3">
              <div className="col-6">
                <strong>Piezas Master:</strong> {masterPieces}
              </div>
              <div className="col-6">
                <strong>Peso Master:</strong> {masterWeight}
              </div>
            </div>

            <table className="table mt-4">
              <thead className="text-center">
                <tr>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Bultos
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Pzas
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Peso
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Locación
                  </th>
                  <th
                    style={{ backgroundColor: "#020C41", color: "white" }}
                  ></th>
                </tr>
              </thead>
              <tbody className="text-center">
                {rows.map((row) => (
                  <tr key={row.id}>
                    <td>{row.id}</td>
                    <td>
                      <input
                        type="number"
                        value={row.pzas}
                        onChange={(e) =>
                          handleInputChange(row.id, "pzas", e.target.value)
                        }
                        className="form-control form-control-sm"
                        min="0"
                        step="0.01"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={row.peso}
                        onChange={(e) =>
                          handleInputChange(row.id, "peso", e.target.value)
                        }
                        className="form-control form-control-sm"
                        min="0"
                        step="0.01"
                      />
                    </td>
                    <td>
                      <CustomSelect
                        options={locationOptions}
                        labelKey="name"
                        value={row.locacion}
                        onSelect={(opt) => handleLocationChange(row.id, opt)}
                      />
                    </td>
                    <td>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDeleteRow(row.id)}
                        disabled={saving}
                      >
                        <RiCloseFill />
                      </button>
                    </td>
                  </tr>
                ))}
                {rows.length === 0 && (
                  <tr>
                    <td colSpan="5" className="text-center text-muted">
                      No hay locaciones registradas. Agrega una fila para
                      comenzar.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="text-center">
              <button
                className="btnn"
                style={{ fontSize: "26px", padding: "0px 20px" }}
                onClick={handleAddRow}
                disabled={saving}
              >
                +
              </button>
            </div>

            {!totalsMatch ? (
              <div className="alert alert-danger text-center mt-3" role="alert">
                <strong>Error!</strong> El peso/piezas total no coincide con los
                de la master. Favor de revisar.
              </div>
            ) : (
              <div className="text-center d-flex justify-content-end mt-3">
                <button
                  className="btnn"
                  onClick={handleAccept}
                  disabled={saving}
                >
                  {saving ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Guardando...
                    </>
                  ) : (
                    "Aceptar"
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationsModal;
